import { render, staticRenderFns } from "./PassReset.vue?vue&type=template&id=0c18b3dc&scoped=true"
import script from "./PassReset.vue?vue&type=script&lang=js"
export * from "./PassReset.vue?vue&type=script&lang=js"
import style0 from "./PassReset.vue?vue&type=style&index=0&id=0c18b3dc&prod&scoped=true&lang=css"
import style1 from "./PassReset.vue?vue&type=style&index=1&id=0c18b3dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c18b3dc",
  null
  
)

export default component.exports